import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { CheckCircle2, Lightbulb } from 'lucide-react';
export function Solution() {
  const solutions = ['CÓMO EMPEZAR EN AMAZON DESDE CERO', 'QUÉ PRODUCTOS ELEGIR', 'CÓMO ANALIZAR CORRECTAMENTE', 'CÓMO LANZAR TU PRODUCTO PASO A PASO', 'CÓMO EVITAR ERRORES QUE CUESTAN DINERO'];
  const results = ['ENTENDER CÓMO FUNCIONA AMAZON DESDE CERO', 'SABER EXACTAMENTE QUÉ PRODUCTO ELEGIR', 'EVITAR ERRORES QUE HACEN PERDER DINERO', 'TENER CLARIDAD EN CADA PASO', 'AVANZAR CON SEGURIDAD'];
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-brand-white py-24 px-6" data-id="element-210">
      <div className="max-w-6xl mx-auto" data-id="element-211">
        {/* Title */}
        <FadeIn data-id="element-212">
          <h2 className="text-3xl md:text-5xl font-bold text-center text-brand-green mb-6 tracking-wide" data-id="element-213">
            ESTE SISTEMA TE ENSEÑA:
          </h2>
        </FadeIn>

        {/* Supporting text */}
        <FadeIn delay={0.1} data-id="element-214">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-215">
            <p className="text-lg md:text-xl text-brand-text/70 mb-3 font-medium" data-id="element-216">
              ESTO NO ES SOLO INFORMACIÓN TEÓRICA…
            </p>
            <p className="text-lg md:text-xl text-brand-green font-semibold flex items-center justify-center gap-2" data-id="element-217">
              <span data-id="element-218">👉</span> ES UN SISTEMA PASO A PASO DISEÑADO PARA QUE SEPAS
              EXACTAMENTE QUÉ HACER DESDE EL INICIO.
            </p>
          </div>
        </FadeIn>

        {/* Two-column layout: content left, image right */}
        <div className="flex flex-col lg:flex-row items-start gap-16 mb-16" data-id="element-219">
          {/* Left column — lists */}
          <div className="flex-1 w-full" data-id="element-220">
            {/* Solutions list */}
            <div className="space-y-4 mb-12" data-id="element-221">
              {solutions.map((item, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-222">
                  <div className="flex items-center gap-4 bg-brand-beige/40 p-5 rounded-xl border border-brand-green/5" data-id="element-223">
                    <CheckCircle2 className="w-7 h-7 text-brand-green flex-shrink-0" data-id="element-224" />
                    <p className="text-lg md:text-xl font-semibold text-brand-text" data-id="element-225">
                      {item}
                    </p>
                  </div>
                </FadeIn>)}
            </div>

            {/* Results block */}
            <FadeIn delay={0.6} data-id="element-226">
              <div className="mb-12" data-id="element-227">
                <div className="flex items-center gap-3 mb-6" data-id="element-228">
                  <Lightbulb className="w-7 h-7 text-brand-gold" data-id="element-229" />
                  <h3 className="text-2xl md:text-3xl font-bold text-brand-green" data-id="element-230">
                    LO QUE REALMENTE VAS A LOGRAR:
                  </h3>
                </div>
                <div className="space-y-3" data-id="element-231">
                  {results.map((item, index) => <div key={index} className="flex items-center gap-4 pl-2" data-id="element-232">
                      <CheckCircle2 className="w-6 h-6 text-brand-gold flex-shrink-0" data-id="element-233" />
                      <p className="text-lg font-medium text-brand-text" data-id="element-234">
                        {item}
                      </p>
                    </div>)}
                </div>
              </div>
            </FadeIn>

            {/* Sin información confusa block */}
            <FadeIn delay={0.7} data-id="element-235">
              <div className="bg-brand-beige rounded-2xl p-8 shadow-sm border border-brand-gold/15" data-id="element-236">
                <p className="text-xl font-semibold text-brand-green mb-4 flex items-center justify-center gap-2" data-id="element-237">
                  <span data-id="element-238">👉</span> SIN INFORMACIÓN CONFUSA
                </p>
                <p className="text-xl font-semibold text-brand-green flex items-center justify-center gap-2" data-id="element-239">
                  <span data-id="element-240">👉</span> SIN PASOS COMPLICADOS
                </p>
              </div>
            </FadeIn>
          </div>

          {/* Right column — Image */}
          <div className="flex-shrink-0 w-full lg:w-[38%] lg:sticky lg:top-24" data-id="element-241">
            <FadeIn delay={0.4} data-id="element-242">
              <img src="https://cdn.magicpatterns.com/uploads/k8a1ewWKihihNeRboYEFkL/ChatGPT_Image_7_abr_2026,_06_45_05.png" alt="Mujer trabajando desde casa con laptop, ambiente cálido y productivo" className="w-full h-auto rounded-2xl shadow-lg object-contain" data-id="element-243" />
            </FadeIn>
          </div>
        </div>

        {/* CTA Button */}
        <FadeIn delay={0.8} data-id="element-244">
          <div className="text-center" data-id="element-245">
            <Button onClick={scrollToPricing} className="text-lg px-10 py-5" data-id="element-246">
              QUIERO EMPEZAR AHORA
            </Button>
          </div>
        </FadeIn>
      </div>
    </section>;
}